<div class="d-flex flex-column justify-content-between h-100 page-container p-4">

    <div class="popup-header">
        <div class="header-left">
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="onClose()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>

    <div class="flex-grow-1" *ngIf="selectedPatient">
        <div class="p-3 rounded">
            <div class="d-flex align-items-center justify-content-between gap-3">
                <div class="d-flex align-items-center gap-3">
                    <div class="avatar-box d-flex align-items-center justify-content-center rounded-circle">
                        <span class="fw-500 fs-14">{{selectedPatient.firstName | initials :
                            selectedPatient.lastName}}</span>
                    </div>
                    <div class="flex-grow-1">
                        <div class="fw-500 fs-14">{{ selectedPatient.firstName }} {{selectedPatient.lastName}}</div>
                        <div class="text-muted fs-12 mt-1">
                            <span>{{ selectedPatient.dateOfBirth | age }}, {{
                                selectedPatient.gender?.charAt(0) || '-' }}</span>
                        </div>
                    </div>
                </div>
                <button class="primaryBtn" (click)="openMedicalEvidence()" *ngIf="role == enumRole.PROVIDER && userId == selectedPatient.serviceRequest[0]?.assignedProvider?.id && 
                selectedPatient.serviceRequest[0]?.status != 'RECEIVED'">
                    Submit Medical Evidence
                </button>

                @if(role == enumRole.INSURER && selectedPatient.serviceRequest[0]?.status == 'RECEIVED'){
                <button class="primaryBtn" (click)="onRequestMoreDetails()">
                    Request More Details
                </button>
                }
            </div>
        </div>

        <div class="custom-card">
            <p class="fs-14 fw-500 sideHead d-flex align-items-center gap-1">

                General Information :
            </p>

            <div class="key-value-grid mt-2 mb-2">
                <div class="key-value-pair">
                    <span class="key gray-text">Phone:</span>
                    <span class="value">{{ selectedPatient.phone }}</span>
                </div>
                <div class="key-value-pair">
                    <span class="key gray-text">Email:</span>
                    <span class="value">{{ selectedPatient.email }}</span>
                    <span class="copy-icon ms-1" style="cursor:pointer;"
                        (click)="copyToClipboard(selectedPatient.email)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="#1976d2"
                                d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                        </svg>
                    </span>
                    <span *ngIf="copiedEmail === selectedPatient.email" class="fs-12 ms-1">
                        Copied!
                    </span>
                </div>

                <div class="key-value-pair">
                    <span class="key gray-text">Address:</span>
                    <span class="value">{{ selectedPatient.address }}</span>
                </div>


                <div class="key-value-pair">
                    <span class="key gray-text">NI Number:</span>
                    <span class="value">{{selectedPatient.nhsNumber}}</span>
                </div>
            </div>

            <span class="fs-12 gray-text" *ngIf="role == enumRole.PROVIDER">
                <a href="javascript:void(0)" (click)="onRequestMoreDetails()">Click here</a>
                to request more details.....
            </span>

            <span class="fs-12"
                *ngIf="role == enumRole.INSURER && selectedPatient.serviceRequest[0]?.status == 'MORE_INFO_REQUESTED'">
                <a href="javascript:void(0)" (click)="onFillMoreInfo()">Click here</a>
                to fill requested details.....
            </span>
        </div>


        <div class="custom-card mt-2" *ngIf="selectedPatient.patientDocuments.length > 0">
            <p class="fs-14 fw-500 sideHead">
                Documents Attached By Insurer :
            </p>
            <div class="attachment-wrapper">
                <div class="attachment-grid">
                    <div class="attachment-card" *ngFor="let doc of selectedPatient.patientDocuments">
                        <a href="javascript:void(0)" (click)="openDocument(doc)" class="attachment-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                <path fill="none" stroke="#3da3ef" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="1.5"
                                    d="M11.688 3.063a3.5 3.5 0 0 1 1.027.712l5.968 5.97c.3.3.54.647.711 1.026m-7.706-7.708a3.5 3.5 0 0 0-1.448-.313H7.792a3.5 3.5 0 0 0-3.5 3.5v11.5a3.5 3.5 0 0 0 3.5 3.5h8.416a3.5 3.5 0 0 0 3.5-3.5v-5.53c0-.505-.109-.999-.314-1.45m-7.706-7.707V8.77a2 2 0 0 0 2 2h5.706" />
                            </svg> {{ doc.documentName }}
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <div class="custom-card mt-2">
            <p class="fs-14 fw-500 sideHead">
                Medical Evidence History :
            </p>
            <div *ngIf="selectedPatient.serviceRequest && selectedPatient.serviceRequest.length!=0">
                <div *ngFor="let activity of selectedPatient.serviceRequest">
                    <div class="activity-item">
                        <ng-container>
                            <div class="activity-icon">
                                {{ activity?.provider?.name?.charAt(0) || '-' }}
                            </div>
                            <div class="activity-content">
                                <span class="user-name"><span class="gray-text">
                                        {{ activity.status === 'RECEIVED' ? 'Submitted by' : 'Requested to'}}
                                    </span> {{ activity.provider.name }}</span>
                                <span class="days-ago">On {{ activity.createdon | date : 'dd MMM yyyy, HH:mm'
                                    }}</span>

                                @if(activity.assignedProvider){
                                <span class="user-name"><span class="gray-text">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                            viewBox="0 0 24 24">
                                            <path fill="none" stroke="#888585"
                                                d="M18.5 20.247V16S16 14.5 12 14.5S5.5 16 5.5 16v4.247M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12S17.799 22.5 12 22.5S1.5 17.799 1.5 12Zm10.426.5S8.5 10.68 8.5 8c0-1.933 1.569-3.5 3.504-3.5A3.495 3.495 0 0 1 15.5 8c0 2.68-3.426 4.5-3.426 4.5z"
                                                stroke-width="1" />
                                        </svg>&nbsp;
                                        Assigned to </span>{{ activity.assignedProvider.firstName + ' ' +
                                    activity.assignedProvider.lastName}}</span>

                                <span class="days-ago"> on {{ activity.assignedProvider.lastupdatedon | date : 'dd MMM
                                    yyyy, HH:mm'
                                    }}</span>
                                }

                            </div>
                        </ng-container>

                        <ng-container>
                            <div class="timeline-card-gradient">

                                <div class="d-flex justify-content-between align-items-center">
                                    <!-- Left: Turn Around Time -->
                                    <div class="d-flex align-items-center">
                                        <span class="fs-12 gray-text">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24">
                                                <path fill="#bdb9b9"
                                                    d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 7h1v5.42l4.7 2.71l-.5.87l-5.2-3z"
                                                    stroke-width="0.1" stroke="#bdb9b9" />
                                            </svg>
                                            Turn Around Time:
                                        </span>
                                        &nbsp;
                                        <span class="fs-12">{{ getTurnAroundTime(activity) }}</span>
                                    </div>

                                    <div>
                                        <app-status-lables [entityType]="enumEntityType.INSURER"
                                            [status]="activity.status === 'RECEIVED' && role === enumRole.PROVIDER ? 'SUBMITTED' : activity.status">
                                        </app-status-lables>

                                    </div>
                                </div>

                                <div class="d-flex flex-wrap gap-2" *ngIf="activity.documents.length > 0">
                                    <p class="fs-14 fw-500 sideHead">Uploaded Documents : </p>
                                    <div class="attachment-wrapper">
                                        <div class="attachment-grid">
                                            <div class="attachment-card" *ngFor="let doc of activity.documents">
                                                <a href="javascript:void(0)" (click)="openDocument(doc)"
                                                    class="attachment-link">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                        viewBox="0 0 24 24">
                                                        <path fill="none" stroke="#3da3ef" stroke-linecap="round"
                                                            stroke-linejoin="round" stroke-width="1.5"
                                                            d="M11.688 3.063a3.5 3.5 0 0 1 1.027.712l5.968 5.97c.3.3.54.647.711 1.026m-7.706-7.708a3.5 3.5 0 0 0-1.448-.313H7.792a3.5 3.5 0 0 0-3.5 3.5v11.5a3.5 3.5 0 0 0 3.5 3.5h8.416a3.5 3.5 0 0 0 3.5-3.5v-5.53c0-.505-.109-.999-.314-1.45m-7.706-7.707V8.77a2 2 0 0 0 2 2h5.706" />
                                                    </svg> {{ doc.documentName }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center align-items-center mt-3 gray-text fs-12"
                                    *ngIf="activity.documents.length == 0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="#b3afaf"
                                            d="M12.002 1.999c5.523 0 10.001 4.478 10.001 10.002c0 5.523-4.478 10.001-10.001 10.001C6.478 22.002 2 17.524 2 12.001C2 6.477 6.478 1.999 12.002 1.999m0 1.5a8.502 8.502 0 1 0 0 17.003a8.502 8.502 0 0 0 0-17.003M12 10.5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75M12 9a1 1 0 1 0 0-2a1 1 0 0 0 0 2" />
                                    </svg>&nbsp;
                                    {{role == enumRole.PROVIDER ? 'Yet to process' : 'Yet to receive the documents'}}
                                </div>

                                <div class="ms-auto text-muted fs-11 mt-5"><svg xmlns="http://www.w3.org/2000/svg"
                                        width="15" height="15" viewBox="0 0 24 24">
                                        <g fill="none" stroke="#5e5d5d" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="1.6">
                                            <circle cx="12" cy="12" r="9" />
                                            <path d="M11 8v5h5" />
                                        </g>
                                    </svg>
                                    Last updated : {{ activity.lastupdatedon | date : 'dd MMM yyyy, HH:mm' }}
                                </div>


                            </div>
                        </ng-container>
                    </div>


                    <div class="fs-13 mb-2 mt-2 comments" *ngIf="activity.comments"><span
                            class="gray-text fs-12">Comments
                            :</span> &nbsp;{{
                        activity.comments }}</div>

                </div>
            </div>

            <div *ngIf="selectedPatient.serviceRequest.length == 0">
                <div class="d-flex justify-content-center align-items-center fs-12">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 40 40">
                        <path fill="#595959"
                            d="M20.75 15.75a1.11 1.11 0 0 0 1.107-1.107v-1.11c0-.605-.497-1.107-1.107-1.107s-1.109.502-1.109 1.107v1.11c0 .609.499 1.107 1.109 1.107m-2.214 4.431h1.105v6.278c0 .609.499 1.107 1.109 1.107a1.11 1.11 0 0 0 1.107-1.107v-7.386a1.11 1.11 0 0 0-1.107-1.107h-2.214c-.611 0-1.109.499-1.109 1.107c0 .61.498 1.108 1.109 1.108m0 0" />
                        <path fill="#595959"
                            d="M20 33.75c-7.582 0-13.75-6.168-13.75-13.749S12.418 6.25 20 6.25s13.75 6.169 13.75 13.751S27.582 33.75 20 33.75m0-26.5c-7.03 0-12.75 5.72-12.75 12.751S12.97 32.75 20 32.75s12.75-5.719 12.75-12.749S27.03 7.25 20 7.25" />
                    </svg>&nbsp;No Records Found
                </div>
            </div>
        </div>

        <div class="custom-card mt-2" *ngIf="selectedPatient.serviceRequest[0]?.requestDetails && selectedPatient.serviceRequest[0].requestDetails.length > 0">
            <p class="fs-14 fw-500 sideHead">Further Details Requested :</p>
            <div class="chat-container">
                <div class="messages-list" #chatMessagesContainer>
                    
                    <div *ngFor="let message of selectedPatient.serviceRequest[0]?.requestDetails" [class.insurer-message]="message.role === 'INSURER'"
                        [class.provider-message]="message.role === 'PROVIDER'" class="chat-message">

                        <div class="message-avatar">{{ message.role === 'PROVIDER' ? 'PR' : 'IN' }}</div>
                        <div class="message-content-wrapper">
                            <div class="message-bubble">
                                <p class="message-comment">{{ message.requestDetails }}</p>
                                <div class="attachment-wrapper message-files" *ngIf="message.documents && message.documents.length > 0">
                                    <div class="attachment-grid">
                                        <div class="attachment-card" *ngFor="let doc of message.documents">
                                            <a href="javascript:void(0)" class="attachment-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24">
                                                    <path fill="none" stroke="#3da3ef" stroke-linecap="round"
                                                        stroke-linejoin="round" stroke-width="1.5"
                                                        d="M11.688 3.063a3.5 3.5 0 0 1 1.027.712l5.968 5.97c.3.3.54.647.711 1.026m-7.706-7.708a3.5 3.5 0 0 0-1.448-.313H7.792a3.5 3.5 0 0 0-3.5 3.5v11.5a3.5 3.5 0 0 0 3.5 3.5h8.416a3.5 3.5 0 0 0 3.5-3.5v-5.53c0-.505-.109-.999-.314-1.45m-7.706-7.707V8.77a2 2 0 0 0 2 2h5.706" />
                                                </svg> {{ doc.fileName }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="message-timestamp">{{ message.lastupdatedon | date : 'dd MMM yyyy, HH:mm' }}</span>
                        </div>
                    </div>

                    <!--
                    <div *ngFor="let message of messages" [class.insurer-message]="message.sender === 'insurer'"
                        [class.provider-message]="message.sender === 'provider'" class="chat-message">

                        <div class="message-avatar">{{ message.avatarInitial }}</div>
                        <div class="message-content-wrapper">
                            <div class="message-bubble">
                                <p class="message-comment">{{ message.comment }}</p>
                                <div class="attachment-wrapper message-files" *ngIf="message.files">
                                    <div class="attachment-grid">
                                        <div class="attachment-card" *ngFor="let doc of message.files">
                                            <a href="javascript:void(0)" class="attachment-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24">
                                                    <path fill="none" stroke="#3da3ef" stroke-linecap="round"
                                                        stroke-linejoin="round" stroke-width="1.5"
                                                        d="M11.688 3.063a3.5 3.5 0 0 1 1.027.712l5.968 5.97c.3.3.54.647.711 1.026m-7.706-7.708a3.5 3.5 0 0 0-1.448-.313H7.792a3.5 3.5 0 0 0-3.5 3.5v11.5a3.5 3.5 0 0 0 3.5 3.5h8.416a3.5 3.5 0 0 0 3.5-3.5v-5.53c0-.505-.109-.999-.314-1.45m-7.706-7.707V8.77a2 2 0 0 0 2 2h5.706" />
                                                </svg> {{ doc.fileName }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="message-timestamp">12/02/2024 11:20</span>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>


    </div>

    <div class="d-flex justify-content-end mt-2">
        <button class="secondaryBtn" (click)="onClose()">
            <span class="btnContent">Close</span>
        </button>
    </div>
</div>